// Alma ERP — تعريف القائمة الجانبية: مجموعات قابلة للطي، كل عنصر له مسار ومفتاح قسم.
// مفاتيح الأقسام (key) تطابق SECTIONS في backend/middleware/auth.js — الأدمن يمنحها لكل مستخدم من إدارة المستخدمين.
// العناصر الموسومة admin تظهر للأدمن فقط ولا تُمنح كأقسام.
export const NAV = [
  { key: "site", label: "الموقع الإلكتروني", icon: "🌐", items: [
    { key: "content", path: "/site/content", label: "محتوى الموقع", icon: "📝" },
    { key: "messages", path: "/site/messages", label: "الرسائل الواردة", icon: "📥" },
    { key: "people", path: "/people", label: "القيادة والأشخاص", icon: "👥" },
    { key: "settings", path: "/site/settings", label: "بيانات التواصل والموقع", icon: "⚙️" },
  ] },
  { key: "governance", label: "الالتزام والحوكمة", icon: "✅", items: [
    { key: "compliance", path: "/compliance", label: "الالتزام التنظيمي (CMA)", icon: "📑" },
    { key: "startup", path: "/startup", label: "متطلبات بدء ممارسة العمل", icon: "📋" },
  ] },
  { key: "social", label: "السوشل ميديا", icon: "📣", items: [
    { key: "social", path: "/social", label: "إدارة السوشل ميديا", icon: "📱" },
  ] },
  { key: "system", label: "النظام", icon: "🛠️", admin: true, items: [
    { key: "users", path: "/system/users", label: "إدارة المستخدمين", icon: "👤", admin: true },
    { key: "audit", path: "/system/audit", label: "سجل النظام", icon: "🧾", admin: true },
  ] },
];

export const ALL_ITEMS = NAV.flatMap((g) => g.items.map((it) => ({ ...it, group: g.key, admin: it.admin || g.admin })));
// الأقسام القابلة للمنح (بلا عناصر الأدمن) — تُستخدم في إدارة المستخدمين
export const GRANTABLE = ALL_ITEMS.filter((it) => !it.admin);
// المسارات القديمة (/?tab=x و /users) → المسارات الجديدة
export const LEGACY_TABS = { content: "/site/content", messages: "/site/messages", settings: "/site/settings", compliance: "/compliance", people: "/people", startup: "/startup" };

export const ROLE_LABEL = { admin: "أدمن", manager: "مدير", viewer: "مشاهد" };
